import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setFilter, cleanState } from '../../actions';
import { useHistory } from 'react-router-dom';
import logoUruk from '../UI/logos/urukcolor.png';

import { Auth } from 'aws-amplify';
import { styles } from '../UI/Menu/TopBar/styles';
import {
  AppBar,
  Toolbar,
  Grid,
  withStyles,
  Typography
} from '@material-ui/core';
import UserMenuSigner from './/UserMenuSigner';
import useWindowSize from '../../customHooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import ChangeLanguage from '../UI/Menu/TopBar/ChangeLanguage';
import SignerLink from '../UI/Menu/TopBar/SignerLink';

const SignerTopBar = (props) => {
  const windowSize = useWindowSize();
  const history = useHistory();
  const { classes } = props;
  const { t } = useTranslation();
  const { customTheme } = props;
  const { user } = props;

  const { logo } = customTheme || { logo: logoUruk };

  const handleLogout = () => {
    Auth.signOut()
      .then(() => {
        history.push('/signer');
        props.resetState();
        sessionStorage.clear();
        window.location.reload();
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <AppBar color='secondary' position='static'>
        <Toolbar>
          {windowSize.width > 990 && (
            <div className={classes.container_logo}>
              <img className={classes.logo} src={logo} alt='Logo' />
            </div>
          )}
          <div className={classes.container_user}>
            <Grid>
              <Grid
                item
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%'
                }}
              >
                <Typography
                  variant='body2'
                  style={{ color: 'white' }}
                  className={classes.user_p}
                >
                  {user.username ? `${user.username}` : t('topBar:username')}
                </Typography>
              </Grid>
            </Grid>
            <UserMenuSigner user={user} handleLogout={handleLogout} />
            {windowSize.width > 990 && <ChangeLanguage />}
            {windowSize.width > 990 && <SignerLink />}
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (data) => dispatch(setFilter(data)),
    resetState: () => dispatch(cleanState())
  };
};

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(SignerTopBar)
);
